import React                   from 'react'
import i18n from '../../../i18n';
import { trackingEvent } from "../layouts/GoogleAnalytics.js"

export default (props) => {
  const { application, toggleDelete } = props;

  return (
    <tr>
      <td className="align-middle text-left">{application.name}</td>
      <td className="align-middle text-right">
        <button type="button" className="btn mfc-btn-gray small mfc-btn-danger" onClick={() => {trackingEvent("Application", "許可を取り消す");toggleDelete(application)}}>{i18n.t("application.delete")}</button>
      </td>
    </tr>
  )
}
